import React, { useState, useCallback, useEffect, useRef } from "react";
import Tempo from "../Tempo";

import { Container } from "./styles";

const LessonAnexo = (props) => {
  const [src, setSrc] = useState("");

  const formatYoutubeSrc = useCallback((youtubeSrc) => {
    if (youtubeSrc.includes("youtube")) {
      if (youtubeSrc.includes("watch")) {
        return `https://www.youtube.com/embed/${
          youtubeSrc.split("?v=").pop().split('"')[0]
        }`;
      }

      if (youtubeSrc.includes("embed")) {
        return `https://www.youtube.com/embed/${
          youtubeSrc.split("embed/").pop().split("/")[0]
        }`;
      }
    }

    if (!youtubeSrc.includes(".")) {
      return `https://www.youtube.com/embed/${youtubeSrc}`;
    }

    return youtubeSrc;
  }, []);

  const formatVimeoSrc = useCallback((vimeoSrc) => {
    return `https://${vimeoSrc.split("://").pop()}`;
  }, []);

  const formatGoogleSrc = useCallback((googleSrc) => {
    return `https://docs.google.com/gview?url=${googleSrc
      .split("://")
      .pop()}&embedded=true`;
  }, []);

  useEffect(() => {
    if (props.youtube) {
      const formatedSrc = formatYoutubeSrc(props.src);

      setSrc(formatedSrc);
      return;
    }

    if (props.vimeo) {
      const formatedSrc = formatVimeoSrc(props.src);

      setSrc(formatedSrc);
      return;
    }

    if (props.google) {
      const formatedSrc = formatGoogleSrc(props.src);

      setSrc(formatedSrc);
      return;
    }

    setSrc(props.src);
  }, [props, formatYoutubeSrc]);

  return <Container loading="lazy" src={src} />;
};

export default LessonAnexo;
